import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { Stack, Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useDispatch } from "../../store";
import { ReduxFormProps } from "../../types/ReduxForm";
import MultiValueTextFieldGroup from "../MultiValueTextFieldGroup";

type OptionalStringListProps = ReduxFormProps & {
  disabled: boolean;
  multiline?: boolean;
  rows?: number;
  validator?: (val: string) => string;
};

const OptionalStringList = ({
  path,
  setter,
  getter,
  disabled,
  multiline,
  rows,
  errorHandler,
  validator,
}: OptionalStringListProps) => {
  const dispatch = useDispatch();
  const textFieldRef = useRef<HTMLInputElement>(null);
  const formValue = useSelector(getter(path, undefined)) as string[];

  useEffect(() => {
    if (errorHandler && validator) {
      const errors =
        formValue?.map((v) => validator(v)).filter((e) => e !== "") || [];
      dispatch(errorHandler({ path, error: errors.join(",") }));
    }
  }, [formValue?.join(",")]);

  return (
    <Stack width="100%">
      <FormControlLabel
        control={
          <Switch
            checked={!!formValue}
            color="primary"
            disabled={disabled}
            onChange={(): void => {
              if (!formValue) {
                setTimeout(() => {
                  textFieldRef?.current?.focus?.();
                });
              }
              dispatch(
                setter({
                  path,
                  value: formValue ? undefined : [""],
                }),
              );
            }}
          />
        }
        label={"Enabled"}
        labelPlacement="start"
      />
      {formValue === undefined ? (
        <></>
      ) : (
        <MultiValueTextFieldGroup
          multiline={multiline}
          rows={rows}
          values={formValue}
          onSave={(values) => dispatch(setter({ path, value: values }))}
          inputRef={textFieldRef}
          error
          validator={validator}
        />
      )}
    </Stack>
  );
};

export default OptionalStringList;
